import React from "react";
import { Line } from "../assets/dummy";
import Header from "../components/Header";
import Footer from "../components/Footer";
import DashboardStats from "../components/DashboardStats";

const backImage = require("../assets/images/background2.jpg");
const meterImage = require("../assets/images/meter.png");

const A = require("../assets/images/brand/1.png");
const B = require("../assets/images/brand/2.png");
const C = require("../assets/images/brand/3.png");
const D = require("../assets/images/brand/4.png");
const E = require("../assets/images/brand/5.png");
const I = require("../assets/images/brand/6.png");
const J = require("../assets/images/brand/7.png");
const F = require("../assets/images/gallery/ins2.jpeg");
const G = require("../assets/images/gallery/ins3.jpeg");
const H = require("../assets/images/gallery/man.jpeg");
const K = require("../assets/images/brand/equiplus.png");

interface PartnerLogo {
  src: string;
  alt: string;
}

export const Home = () => {
  const logos: PartnerLogo[] = [
    { src: A, alt: "Costech logo" },
    { src: B, alt: "Partner" },
    { src: C, alt: "Logo" },
    { src: D, alt: "Ruwasa" },
    { src: E, alt: "Logo" },
    { src: I, alt: "Logo" },
    { src: J, alt: "Logo" },
    { src: K, alt: "Equiplus" },
  ];
  return (
    <div className="flex w-full justify-center overflow-x-hidden bg-white">
      <div className="flex min-h-screen w-full flex-col">
        <Header />

        {/* Hero Section */}
        <section className="relative bg-black">
          <div className="absolute inset-0 z-10 bg-gradient-to-r from-black opacity-80"></div>
          <img
            src={backImage}
            alt="Background"
            className="absolute inset-0 z-0 h-1/2 w-full object-cover md:h-full"
          />

          {/* Meter Image and Descriptions */}
          <div className="absolute inset-0 z-20 flex h-full w-full items-center justify-center">
            <div className="relative left-[88px] top-[-138px] max-w-[120px] md:left-[168px] md:top-3.5 md:max-w-[240px] lg:left-[230px] lg:max-w-[326px]">
              <img
                src={meterImage}
                alt="Meter"
                width="840"
                height="auto"
                className="block"
              />

              {/* Feature descriptions */}
              <div className="absolute hidden text-sm font-semibold text-white md:bottom-[314px] md:left-[-112px] md:block lg:bottom-[412px] lg:left-[-82px]">
                <div className="relative max-w-[175px]">
                  <p>Long lasting battery</p>
                  <p>of 6 to 8 years of charge</p>
                  <div className="absolute bottom-[-50px] right-0 flex max-w-[175px] scale-y-[-1] transform justify-end overflow-hidden">
                    <Line />
                  </div>
                </div>
              </div>

              <div className="absolute bottom-[58px] hidden text-sm font-semibold text-white md:left-[-152px] md:block lg:left-[-140px]">
                <div className="relative max-w-[200px]">
                  <p>IP68 Protection</p>
                  <p>against water and dust</p>
                  <div className="absolute bottom-[-10px] left-0 flex max-w-[206px] justify-end overflow-hidden">
                    <Line />
                  </div>
                </div>
              </div>

              <div className="absolute bottom-[-28px] hidden text-sm font-semibold text-white md:right-[-92px] md:block lg:right-[-74px]">
                <div className="relative max-w-[280px] lg:max-w-[250px]">
                  <p>Enjoy the most efficient repayment</p>
                  <p>with STS token technology</p>
                  <div className="absolute bottom-[-10px] left-[-12px] flex max-w-[258px] scale-x-[-1] transform justify-end overflow-hidden">
                    <Line />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Big Text Section */}
          <div className="xs:px-8 container relative z-20 min-h-[568px] pt-[230px] text-white md:pt-[170px] lg:min-h-[760px] lg:pt-[184px]">
            <div className="">
              <h1 className="font-oswald mb-4 text-4xl font-semibold leading-10 md:mb-6 md:text-5xl lg:text-6xl">
                <p>HARNESS</p>
                <p>THE POWER OF</p>
                <p>STS WATER METER</p>
              </h1>
              <a
                href="#"
                className="ignore-has-link inline-block focus:outline-none"
              >
                <div className="font-oswald flex w-full items-center justify-center rounded-md bg-blue-800 px-4 py-2 text-lg uppercase leading-6 text-white transition-all duration-200 hover:bg-blue-800 md:py-4 md:text-xl">
                  <div className="text-left font-medium">Discover More</div>
                </div>
              </a>
            </div>

            <div className="font-oswald mt-[42px] flex flex-col items-start font-semibold md:mt-[100px] md:flex-row md:items-center lg:mt-36">
              <a href="/products">JOIN OUR WISHLIST &gt;&gt;</a>
              <span className="my-1 ml-2 w-px rotate-90 transform md:mx-6 md:my-0 md:rotate-0">
                |
              </span>
              <button
                type="button"
                className="cursor-pointer font-semibold outline-none focus:outline-none"
              >
                REACH OUT TO US &gt;&gt;
              </button>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-24 px-4 md:px-8 bg-white text-gray-600">
          <h2 className="font-oswald mb-12 text-center text-3xl">
            Our Partners and Clients
          </h2>

          {/* Small screens: Grid */}
          <div className="grid grid-cols-2 gap-6 sm:hidden">
            {logos.map((logo, idx) => (
              <img
                key={idx}
                src={logo.src}
                alt={logo.alt}
                className="mx-auto h-auto w-20 object-contain"
              />
            ))}
          </div>

          {/* Large screens: Scrolling animation */}
          <div className="hidden sm:block overflow-hidden">
            <div className="group relative w-full overflow-hidden">
              <div className="flex w-max animate-scroll space-x-16 group-hover:pause">
                {[...logos, ...logos].map((logo, idx) => (
                  <img
                    key={idx}
                    src={logo.src}
                    alt={logo.alt}
                    className="h-20 w-20 object-contain transition-transform duration-300 hover:scale-105"
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Our focus */}
        <section className="px-4 pb-12 md:px-8 md:pb-16 lg:px-16 lg:pb-24">
          <h2 className="font-oswald mb-4 text-center text-2xl font-bold uppercase text-blue-800 md:mb-8 md:text-4xl lg:text-6xl">
            Our Focus
          </h2>
          <p className="font-poppins mx-auto mb-8 max-w-2xl text-center text-gray-600 md:mb-12">
            When developing our products, we primarily focus on three main
            pillars - reliability, security, and ease of use. We believe these
            elements are essential for the success of any IoT project.
          </p>

          {/* Feature Section */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-8">
            <div className="min-w-[250px] max-w-xs flex-1 rounded-xl bg-slate-200 p-6 text-center md:max-w-md md:p-8">
              <h3 className="font-oswald mb-2 text-2xl font-semibold text-blue-800 lg:text-3xl">
                DESIGN
              </h3>
              <p className="font-poppins text-sm text-gray-600">
                Nyirendas company brightest minds are behind the design of our
                connectivity products. Located in SIDO, Dar es Salaam, our
                in-house R&D develops new products quickly and efficiently,
                responding to market needs. At the same time, we continuously
                enhance our existing portfolio by adding new features and
                expanding functionality.
              </p>
            </div>

            <div className="min-w-[250px] max-w-xs flex-1 rounded-xl bg-slate-200 p-6 text-center md:max-w-md md:p-8">
              <h3 className="font-oswald mb-2 text-2xl font-semibold text-blue-800 lg:text-3xl">
                MANUFACTURE
              </h3>
              <p className="font-poppins text-sm text-gray-600">
                Hydroxy prepaid water devices are manufactured and assembled in
                our leading-edge manufacturing facility in SIDO vingunguti, Dar
                es Salaam. Having in-house manufacturing allows our engineers to
                ensure the highest quality of all our products. Every single
                piece is extensively tested before leaving our warehouse.
              </p>
            </div>

            <div className="min-w-[250px] max-w-xs flex-1 rounded-xl bg-slate-200 p-6 text-center md:max-w-md md:p-8">
              <h3 className="font-oswald mb-2 text-2xl font-semibold text-blue-800 lg:text-3xl">
                INSTALLATION
              </h3>
              <p className="font-poppins text-sm text-gray-600">
                Our experienced team ensures seamless installation of the
                prepaid water meters, adapting to various environments across
                the country. We prioritize minimal disruption and guarantee that
                the system integrates smoothly with existing infrastructure,
                ensuring immediate operational efficiency upon setup.
              </p>
            </div>
          </div>
        </section>

        {/* Our Products */}
        <section className="flex w-full items-center justify-center">
          <div className="container mx-auto flex flex-col items-center rounded-lg bg-gray-100 px-4 py-8 md:flex-row md:px-8">
            <div className="flex justify-center md:w-1/2">
              <img
                src={require("../assets/images/meter_alt.png")}
                loading="lazy"
                alt="image alt"
                className="h-auto w-40 object-contain md:w-60"
              />
            </div>
            <div className="flex-1 flex-col justify-center border-gray-300 md:ml-8 md:mt-0 md:flex md:min-w-[320px] md:border-b md:border-t">
              <h3 className="md:text-3.5xl font-oswald mb-2 text-2xl font-semibold uppercase text-blue-800">
                Hydroxy Prepaid Water Meter
              </h3>
              <div className="font-poppins mb-2 hidden max-w-4xl whitespace-pre-wrap text-left text-gray-700 md:block">
                <p>
                  The Hydroxy Prepaid Water Meter provides reliable water usage
                  tracking and payment solutions, offering both residential and
                  commercial customers a convenient and secure method for
                  managing water consumption.{" "}
                </p>
              </div>
              <div>
                <div className="mt-4 flex items-center space-x-4 py-2">
                  <img
                    src={require("../assets/images/logo/1.png")}
                    alt="IP68"
                    className="h-10 w-10 rounded-lg bg-[#022089] px-2 py-2"
                  />
                  <p className="font-poppins text-gray-500">
                    IP68 Protected Casing
                  </p>
                </div>
                <div className="flex items-center space-x-4 py-2">
                  <img
                    src={require("../assets/images/logo/2.png")}
                    alt="STS"
                    className="h-10 w-10 rounded-lg bg-[#022089] px-2 py-2"
                  />
                  <p className="font-poppins text-gray-500">
                    STS Token Repayment
                  </p>
                </div>
                <div className="flex items-center space-x-4 py-2">
                  <img
                    src={require("../assets/images/logo/3.png")}
                    alt="Mobile"
                    className="h-10 w-10 rounded-lg bg-[#022089] px-2 py-2"
                  />
                  <p className="font-poppins text-gray-500">Mobile Payment</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Software */}
        <section className="flex w-full items-center justify-center">
          <div className="container mx-auto mt-20 flex flex-col items-center justify-center bg-gray-100 md:flex-row md:px-8">
            <div className="mt-2 flex-1 flex-col justify-center border-gray-300 md:mr-8 md:mt-0 md:flex md:min-w-[320px] md:border-b md:border-t md:py-4">
              <h3 className="md:text-3.5xl font-oswald mb-2 text-2xl font-semibold uppercase text-blue-800">
                Hydroxy Prepaid Water Meter
              </h3>
              <div className="font-poppins mb-4 hidden max-w-4xl whitespace-pre-wrap text-left text-gray-700 md:block">
                <p>
                  Our software offers complete management of prepaid water
                  meters, allowing utility providers to monitor, track, and
                  manage water usage, payments, and meter data from a
                  centralized platform.
                </p>
              </div>
              <div>
                <div className="flex items-center space-x-4 py-2">
                  <img
                    src={require("../assets/images/logo/meter_logo.png")}
                    alt="IP68"
                    className="h-10 w-10 rounded-lg bg-[#022089] px-2 py-2"
                  />
                  <p className="font-poppins text-gray-500">Meter Management</p>
                </div>
                <div className="flex items-center space-x-4 py-2">
                  <img
                    src={require("../assets/images/logo/user_logo.png")}
                    alt="STS"
                    className="h-10 w-10 rounded-lg bg-[#022089] px-2 py-2"
                  />
                  <p className="font-poppins text-gray-500">
                    Manage your Subscribers
                  </p>
                </div>
                <div className="flex items-center space-x-4 py-2">
                  <img
                    src={require("../assets/images/logo/transactions_logo.png")}
                    alt="Mobile"
                    className="h-10 w-10 rounded-lg bg-[#022089] px-2 py-2"
                  />
                  <p className="font-poppins text-gray-500">
                    Make Transactions seamlessly
                  </p>
                </div>
              </div>
            </div>
            <div className="custom-width">
              <div className="pb-3/5 md:pb-2/3 relative rounded-xl">
                <img
                  src={require("../assets/images/desktop.png")}
                  alt="software"
                  loading="lazy"
                  className="h-auto w-[640px] object-cover object-right"
                />
              </div>
            </div>
          </div>
        </section>
        <DashboardStats />

        {/* Our Gallery */}
        <section className="mb-12 w-full items-center justify-center px-4 pt-16 md:pt-24">
          <div className="mb-6 flex flex-col items-center justify-center">
            <h2 className="md:leading-72 font-oswald mb-2 whitespace-pre-wrap text-center text-2xl font-bold uppercase text-blue-800 md:mb-4 md:text-6xl">
              OUR GALLERY
            </h2>
            <div className="">
              <a
                href="/gallary"
                className="link font-poppins rounded-lg bg-gray-200 px-2 py-1 text-center text-base text-gray-600 underline underline-offset-2 md:-mb-4"
              >
                see more+
              </a>
            </div>
          </div>

          <div className="c-hide-scrollbar -mx-5 mt-12 flex items-center justify-center whitespace-nowrap md:mx-0 md:w-full md:whitespace-normal">
            {/* Image Card */}
            {[
              {
                src: require("../assets/images/gallery/man.jpeg"),
                date: "September 17, 2024",
                title: "Manufucturing of prepaid water meter",
              },
              {
                src: require("../assets/images/gallery/ins2.jpeg"),
                date: "September 11, 2024",
                title: "Installation of Prepaid Water Meters in Kisiju",
              },
              {
                src: require("../assets/images/gallery/ins3.jpeg"),
                date: "September 4, 2024",
                title: "Installation of Prepaid Water Meters in Kisemvule",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="mr-4 flex-1 border-r border-gray-300 pr-4 first:ml-5 last:mr-5 last:pr-0 md:max-w-md md:border-none"
              >
                <a href="#" className="block min-w-[226px] md:w-full">
                  <div className="pb-2/3 relative mb-2 overflow-hidden rounded-xl">
                    <img
                      src={item.src}
                      alt="article"
                      className="h-80 w-full object-cover"
                    />
                    <div className="custom-gradient absolute inset-0"></div>
                  </div>
                  <div className="whitespace-nowrap text-xs capitalize text-gray-500 md:text-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon sprite-globals -mt-1 mr-2 inline-block h-4 w-4 align-middle"
                    >
                      <use href="/_nuxt/b26c2a3e8e08968fd3a076422b8988bf.svg#i-clock"></use>
                    </svg>
                    {item.date}
                  </div>
                  <div className="font-oswald mt-2 whitespace-normal font-semibold uppercase text-black md:text-2xl">
                    {item.title}
                  </div>
                </a>
              </div>
            ))}
          </div>
        </section>

        <section className="px mb-16 flex w-full items-start justify-center md:mb-24">
          <div className="rounded-xl bg-blue-800 p-4 text-white lg:px-16 lg:py-12">
            <div className="items-center justify-between lg:flex">
              <div className="font-oswald lg:text-3.5xl mb-2 flex-1 text-2xl font-semibold uppercase lg:mb-0 lg:flex-none">
                GET THE LATEST NEWS TO YOUR INBOX
              </div>
              <div className="flex-1">
                <form className="flex w-full items-baseline justify-center text-left sm:block">
                  <div className="w-full items-start lg:flex">
                    <div
                      className="relative flex-1 lg:ml-16 lg:mr-2"
                      data-v-95cdc4d6=""
                    >
                      <div
                        className="shadow-component-input shadow-outline-gray group-hover:border-gray-4 focus:shadow-outline-white-2x focus-within:shadow-outline-white-2x hover:focus-within:border-gray-4 group min-h-[48px] rounded-lg border-white bg-gray-800 px-3 py-2 text-gray-400 transition duration-150 hover:border-gray-600"
                        data-v-95cdc4d6=""
                      >
                        <label
                          htmlFor="1727535161759"
                          className="block h-4 overflow-hidden text-xs group-hover:text-white group-focus:text-white"
                          data-v-95cdc4d6=""
                        >
                          Your email address
                        </label>
                        <div className="text-gray-400" data-v-95cdc4d6="">
                          <input
                            id="1727535161759"
                            type="text"
                            name=""
                            value=""
                            className="block w-full appearance-none bg-transparent font-medium text-current outline-none"
                            data-v-95cdc4d6=""
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        tabIndex={1}
                        type="button"
                        className="ignore-has-link width--large mt-6 inline-block w-full focus:outline-none lg:m-0 lg:mt-1 lg:w-auto"
                      >
                        <div
                          tabIndex={-1}
                          className="content font-oswald hover:bg-gray-2 active-border--light px--small flex w-full items-center justify-center rounded-md bg-white px-4 py-2 text-lg uppercase leading-6 text-blue-800 transition-all duration-200 hover:text-white md:w-auto md:text-base"
                        >
                          <div className="text-left font-medium">
                            Sign me up
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Home;
